/** Video extensions accepted for CMS upload (mirrors the converter whitelist). */
export const VIDEO_EXTENSIONS = [".mp4", ".mov", ".qt", ".avi", ".webm"] as const;

/** MIME types accepted for video upload. */
export const ACCEPTED_VIDEO_MIME_TYPES = [
  "video/mp4",
  "video/quicktime",
  "video/x-msvideo",
  "video/webm",
  // Non-standard but reported by some browsers/OSes:
  "video/avi",
  "video/mov",
] as const;

export function getFileExtension(fileName: string): string {
  const idx = fileName.lastIndexOf(".");
  return idx >= 0 ? fileName.slice(idx).toLowerCase() : "";
}

export function isAcceptedVideoFile(file: File): boolean {
  if (
    (ACCEPTED_VIDEO_MIME_TYPES as readonly string[]).includes(file.type)
  ) {
    return true;
  }
  return (VIDEO_EXTENSIONS as readonly string[]).includes(
    getFileExtension(file.name),
  );
}

/** Detects a video file from MIME type or file extension. */
export function isVideoFile(file?: File | null): boolean {
  if (!file) return false;
  if (file.type.startsWith("video/")) return true;
  return isAcceptedVideoFile(file);
}

/** react-dropzone accept map for videos (includes fallback for unknown MIME). */
export const VIDEO_DROPZONE_ACCEPT: Record<string, string[]> = {
  "video/mp4": [".mp4"],
  "video/quicktime": [".mov", ".qt"],
  "video/x-msvideo": [".avi"],
  "video/webm": [".webm"],
  "video/avi": [".avi"],
  "video/mov": [".mov"],
  // macOS / Windows sometimes report MOV/AVI as octet-stream:
  "application/octet-stream": [".mov", ".avi"],
};
